export const APPLY_FILTERS = 'footballPlayers/APPLY_FILTERS';


// WEBPACK FOOTER //
// ./src/footballPlayers/actionTypes/filters.js